export default __webpack_public_path__ + "static/media/settle-6.031bea92.png";